import React from 'react';
import { CheckIcon, GlobeIcon, ZapIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
const valueRows = [{
  item: 'Sistema de Decisión Clínica (6 Tomos)',
  value: 'USD $97'
}, {
  item: 'Kit Profesional de Consulta (5 Bonos)',
  value: 'USD $140'
}];
const includes = ['Un único pago, sin mensualidades', 'Sin costos ocultos', 'Acceso inmediato tras la compra', 'Actualizaciones incluidas en esta edición'];
export function Offer() {
  return <Section tone="cream" id="oferta" data-id="element-224" data-mp="3jwjld86aofgg">
      <Eyebrow data-id="element-225" data-mp="3jxmfdoywyy0l">Oferta especial de lanzamiento</Eyebrow>
      <Heading data-id="element-226" data-mp="3nvk3eogy7e2e">
        Todo el sistema por menos de lo que cuesta un <span className="italic text-brand" data-id="element-227" data-mp="3sw6r266247fb">café</span>
      </Heading>

      <div className="mt-8 overflow-hidden rounded-3xl border-2 border-navy/15 bg-white shadow-[0_20px_50px_-24px_rgba(11,27,58,0.35)]" data-id="element-228" data-mp="3stu1p7xyyus8">
        <div className="bg-navy px-4 py-3 text-center" data-id="element-229" data-mp="1klzunc6htsma">
          <p className="text-[11.5px] font-extrabold uppercase tracking-[0.2em] text-brand-light" data-id="element-230" data-mp="1kjdn3cjlrd42">
            Lo que recibes hoy
          </p>
        </div>

        <div className="p-4 sm:p-6" data-id="element-231" data-mp="1blthjrepiunn">
          <ul className="divide-y divide-navy/10" data-id="element-232" data-mp="1bmw981jut14m">
            {valueRows.map(row => <li key={row.item} className="flex items-start justify-between gap-3 py-3" data-id="element-233" data-mp="16njmdgszfu21">
                <span className="text-[14px] font-semibold leading-snug text-navy sm:text-[15px]" data-id="element-234" data-mp="23bg3qnw8uteb">
                  {row.item}
                </span>
                <span className="shrink-0 text-[14px] font-bold text-navy/45 line-through sm:text-[15px]" data-id="element-235" data-mp="1uj4hle85xs45">
                  {row.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-3 py-3" data-id="element-236" data-mp="2mzoz16t33fi1">
              <span className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-237" data-mp="2n21m1ydp8g1y">
                Valor total
              </span>
              <span className="shrink-0 font-serif text-xl font-extrabold text-navy/45 line-through" data-id="element-238" data-mp="3157eii4e7aoc">
                USD $237
              </span>
            </li>
          </ul>

          <div className="mt-4 rounded-2xl bg-brand-soft px-4 py-5 text-center" data-id="element-239" data-mp="2sdf58ar3u7lc">
            <p className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-brand" data-id="element-240" data-mp="2wer12y0knp1z">
              Hoy puedes acceder por solo
            </p>
            <p className="mt-1 flex items-end justify-center gap-1" data-id="element-241" data-mp="2ie7vrynhqx3i">
              <span className="font-serif text-[16px] font-bold text-navy/60" data-id="element-242" data-mp="2nelugq37cuov">USD</span>
              <span className="font-serif text-[68px] font-black leading-[0.85] tracking-tight text-navy sm:text-[86px]" data-id="element-243" data-mp="29ekr93zgtb68">
                $15
              </span>
            </p>
            <p className="mt-2 inline-flex rounded-full bg-good px-3 py-1 text-[11.5px] font-extrabold uppercase tracking-wide text-white" data-id="element-244" data-mp="2dhptd5fmvauc">
              Ahorras USD $223 (94%)
            </p>
          </div>

          <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-245" data-mp="1w6k9t2rrnvkp">
            {includes.map(item => <li key={item} className="flex items-start gap-2" data-id="element-246" data-mp="1s4z1luq6g5gu">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-good" aria-hidden="true" data-id="element-247" data-mp="1s6jt1bh738ah" />
                <span className="text-[13.5px] font-semibold leading-snug text-navy/80" data-id="element-248" data-mp="25xydlmqr3hjn">{item}</span>
              </li>)}
          </ul>

          <div className="mt-5" data-id="element-249" data-mp="2fub6wjidvtdv">
            <CTAButton label="✅ Quiero el Sistema de Decisión Clínica" data-id="element-250" data-mp="2fti5zz63vy3n" />
          </div>

          <div className="mt-4" data-id="element-251" data-mp="2aw9s4arzqg87">
            <CountdownTimer data-id="element-252" data-mp="2av6znyf0s5q6" />
          </div>

          <div className="mt-4" data-id="element-253" data-mp="2ovriuvouk3k7">
            <ScarcityBar data-id="element-254" data-mp="2otyc7ge8hjc7" />
          </div>

          <div className="mt-4 flex items-start gap-2.5 rounded-2xl border border-brand/25 bg-brand-soft/60 px-3.5 py-3" data-id="element-255" data-mp="2osvhsyhpcyrj">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-256" data-mp="ugovp4n9sxkg" />
            <p className="text-[13px] font-semibold leading-snug text-navy/80" data-id="element-257" data-mp="pido70kg6z5e">
              <strong className="font-extrabold text-navy" data-id="element-258" data-mp="pki1g948laic">Cambio de moneda automático:</strong> pagas
              en la moneda de tu país. La plataforma convierte los USD $14 automáticamente al momento
              del pago.
            </p>
          </div>

          <p className="mt-3.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-[11.5px] font-semibold text-navy/55" data-id="element-259" data-mp="10ys29mtxd0ha">
            <ZapIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-260" data-mp="88tavks9cr9g" />
            Descarga inmediata • Acceso de por vida • Pago único
          </p>
        </div>
      </div>
    </Section>;
}